import { ButtonLink } from "../../models/ButtonLink.ts";
import LinkHandler from "./LinkHandler.tsx";
import { ToastContainer, toast } from 'react-toastify';

const Button: React.FC<any> = ({ actionButtons, setActionButtons }) => {

  const addButton = () => {
    if (actionButtons?.length == 3) {
      toast.warn(`Maximum button count is 3`, { autoClose: 2000 });
      return;
    }

    setActionButtons((prev) => [...prev, new ButtonLink(null)]);
  };

  const updateButton = (idx: number, value: string) => {
    setActionButtons((prev) =>
      prev.map((btn, i) => (i === idx ? { ...btn, text: value } : btn))
    );
  };

  const removeButton = (index: number) => {
    
    const btns = actionButtons.filter((_, idx)=> idx != index);
    setActionButtons([...btns]);
  };


  return (
    <>
      {actionButtons.map((button, idx) => (
        <div key={button.id || idx} className="relative">
          <img 
            src={require("../../assets/node/close.png")} 
            width={12} 
            className="close-btn" 
            onClick={() => removeButton(idx)} 
            alt="Remove"
            style={{ cursor: 'pointer' }}
          />
          <input
            type="text"
            value={button.text || ""}
            className="input-text-center"
            maxLength={20}
            onChange={(e) => updateButton(idx, e.target.value)}
            placeholder={`Button ${idx + 1}`}
          />
          <LinkHandler idx={button.id} />
          <div className="input-restriction">{(button.text || "").length}/20</div>
        </div>
      ))}
      <button onClick={addButton} className="font-label">+ Add Button</button>
    </>
  )
}

export default Button;